import { T } from '@/design/tokens';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        role="status"
        aria-label="Loading session"
        style={{
          minHeight: '100dvh',
          display: 'grid',
          placeItems: 'center',
          background: T.bg,
          color: T.textMuted,
        }}
      >
        …
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
